import { render, staticRenderFns } from "./AdvisorEditView.vue?vue&type=template&id=56eeb2f2"
import script from "./AdvisorEditView.vue?vue&type=script&lang=js"
export * from "./AdvisorEditView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports